import React, { useEffect, useRef } from 'react';

const Song = ({ song, isPlaying, onPlay }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!audioRef.current) return;

    const audio = audioRef.current;

    // Configura el evento 'ended' para detectar cuando la canción termina
    const handleSongEnd = () => {
      onPlay(null); // Desactiva la canción
    };

    audio.addEventListener('ended', handleSongEnd);

    if (isPlaying) {
      audio.play().catch(e => console.error("Error al reproducir:", e));
    } else {
      audio.pause();
      audio.currentTime = 0;
    }

    // Limpieza al desmontar el componente
    return () => {
      audio.removeEventListener('ended', handleSongEnd);
    };
  }, [isPlaying, onPlay]);

  const handlePlay = () => {
    if (!isPlaying) {
      onPlay(song);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <img
        src={`./covers/${song}.png`}
        alt="Album cover"
        className={`w-[135px] h-[135px] sm:w-40 sm:h-40 rounded ${
          isPlaying 
            ? 'ring-8 ring-yellow-500 cursor-default' 
            : 'cursor-pointer hover:opacity-80'
        }`}
        onClick={handlePlay}
        onTouchStart={!isPlaying ? handlePlay : undefined}
      />
      <audio
        ref={audioRef}
        src={`./music/${song}.mp3`}
        preload="auto"
      />
    </div>
  );
};

export default Song;